import { useState } from 'react';
import axios from 'axios';
import './BookShipmentDialog.css';
import { useNavigate } from 'react-router-dom';
import LoadingDialog from './LoadingDialog';
import BACKEND_URL from '../config';

const BookShipmentDialog = ({ isOpen, onClose, quote, showAlert, removeRowsWithSameSalesOrder }) => {
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    if (!isOpen || !quote) {
        return null;
    }

    const handleBookShipment = async () => {
        setIsLoading(true);
        try {
            const response = await axios.post(`${BACKEND_URL}/api/book-shipment`, { quote }, { withCredentials: true });
            if (response.status === 200) {
                showAlert('Success', 'Shipment booked successfully!');
                removeRowsWithSameSalesOrder(quote["Sales Order"]);
                onClose();
            } else {
                const errorMessage = response.data?.error || 'Failed to book shipment. Please try again.';
                showAlert('Error', errorMessage);
            }
        } catch (error) {
            if (error.response?.status === 401) {
                navigate('/tms');
            } else {
                const errorMessage = error.response?.data?.error || `An unexpected error occurred: ${error.message}`;
                showAlert('Error', errorMessage);
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            {isLoading && <LoadingDialog />}
            <div className="dialog-overlay">
                <div className="dialog">
                    <h2>Booking Confirmation</h2>
                    <p><strong>Sales Order:</strong> {quote["Sales Order"]}</p>
                    <p><strong>Carrier:</strong> {quote["Carrier"]}</p>
                    <p><strong>Quote ID:</strong> {quote["Quote ID"]}</p>
                    <p><strong>Total Charges:</strong> {quote["Total Cost"]}</p>

                    <div className="dialog-buttons">
                        <button onClick={handleBookShipment}>Book Shipment</button>
                        <button onClick={onClose}>Cancel</button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BookShipmentDialog;
